import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// API error → always a plain string (FastAPI 422 `detail` is an array of objects; rendering it crashes React).
export function apiErrorText(error, fallback = "Something went wrong. Please try again.") {
  const d = error?.response?.data?.detail;
  if (typeof d === "string" && d.trim()) return d;
  if (Array.isArray(d) && d.length) {
    return d.map((x) => {
      const field = Array.isArray(x?.loc) ? x.loc.filter((p) => p !== "body").join(" ").replace(/_/g, " ") : "";
      return field ? `${field}: ${x?.msg || "invalid"}` : (x?.msg || String(x));
    }).join(" · ");
  }
  if (d && typeof d === "object") return d.message || JSON.stringify(d);
  return fallback;
}
